import React from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css"; // AOS styles
import {
  Target,
  Heart,
  MousePointer,
  Settings,
  Facebook,
  Instagram,
  Linkedin,
  ArrowRight,
} from "lucide-react";
import dp from "../../assets/images/mainbgg.webp";
import { FaTrophy, FaStar } from "react-icons/fa";
import pic1 from "../../assets/images/COLLABORATIVE TEAM.png";
import pic2 from "../../assets/images/WhatsApp Image 2025-05-12 at 00.43.38_5fa8f748.jpg";
import dp1 from "../../assets/images/pic1.jpg";
import { Link } from "react-router-dom";
import dp3 from "../../assets/images/pic3.jpg";
import dp4 from "../../assets/images/pic4.jpg";
import dp5 from "../../assets/images/pic5.JPG";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

const Home = () => {
  React.useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const [formData, setFormData] = React.useState({
    service: "",
    name: "",
    email: "",
    phone: "",
    subject: "",
    description: "",
  });

  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = React.useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(
        "https://api.einfachesdeutsch.com/rightOnTime",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        console.error("Error:", error);
        toast.error(
          "❌ There was an error submitting the form. Please try again."
        );
      }

      const data = await response.json();
      console.log("Success:", data);

      // Show success dialog
      setShowSuccessDialog(true);

      // Reset form
      setFormData({
        service: "",
        name: "",
        email: "",
        phone: "",
        subject: "",
        description: "",
      });
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        "❌ There was an error submitting the form. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const services = [
    {
      // icon: <Target className="h-8 w-8" />,
      title: "🌐 Customer Experience Solutions (BPO)",
      description:
        "We provide top-tier BPO services, ensuring seamless customer interactions and operational efficiency:",
      services: [
        {
          text: "📞 Inbound Calls",
          path: "/inbound",
        },
        {
          text: "📤 Outbound Calls",
          path: "/outbound",
        },
        {
          text: "💬 Email and Chat Support",
          path: "/email-support",
        },
        {
          text: "📱 SMS Support",
          path: "/sms-support",
        },
      ],
      mainPath: "/bpo",
    },
    {
      // icon: <Heart className="h-8 w-8" />,
      title: "🏥 Healthcare Support Services",
      description:
        "Streamline your healthcare operations with our specialized solutions:",
      services: [
        {
          text: "🧾 Medical Billing",
          path: "/medical-billing",
        },
        {
          text: "📝 Medical Transcription",
          path: "/medical-transcription",
        },
        {
          text: "🏥 Healthcare Management",
          path: "/excellence",
        },
      ],
      mainPath: "/healthcare",
    },
    {
      // icon: <MousePointer className="h-8 w-8" />,
      title: "📈 Digital Growth Strategies",
      description:
        "Reach and engage your target audience with our tailored digital strategies:",
      services: [
        {
          text: "🎨 Graphic Designing",
          path: "/graphics",
        },
        {
          text: "🔍 SEO",
          path: "/seo",
        },
        {
          text: "📱 Social Media Marketing",
          path: "/social",
        },
        {
          text: "✍️ Content Writing",
          path: "/content",
        },
      ],
      mainPath: "/digital-marketing",
    },
    {
      // icon: <Settings className="h-8 w-8" />,
      title: "Software Development",
      description: "💻 Next-Gen Software Development",
      services: [
        {
          text: "💻 Web Development",
          path: "/web",
        },
        {
          text: "🧠 UI/UX Design",
          path: "/uiux",
        },
        {
          text: "🛠️ WordPress Development",
          path: "/wordpress",
        },
      ],
      mainPath: "/software-development",
    },
  ];
  const team = [
    {
      image: dp3,
      name: "M Ahmed Bhatti ",
      role: "CEO",
      description:
        "Leading strategic financial management for sustainable growth.",
    },
    {
      image: dp4,
      name: "Nighat Bhutto",
      role: "Director External Relations",
      description:
        "Driving innovation and delivering transformative solutions nationwide.",
    },
    {
      image: dp1,
      name: "Muhammad Noman",
      role: "Director Finance & Oversight",
      description:
        "Ensuring operational excellence through strategic leadership.",
    },
    {
      image: dp5,
      name: "Umar Shahzad",
      role: "Director Operations",
      description:
        "Ensuring operational excellence through strategic leadership.",
    },
  ];

  const roadmap = [
    {
      step: "1",
      title: "Discover Your Vision",
      description:
        "We take time to understand your unique needs, challenges, and goals.",
    },
    {
      step: "2",
      title: "Design Tailored Strategies",
      description:
        "Our experts design customized strategies and solutions that align with your business objectives.",
    },
    {
      step: "3",
      title: "Deliver Real Results",
      description:
        "From concept to execution, we ensure timely delivery of impactful results.",
    },
    {
      step: "4",
      title: "Drive Continuous Innovation",
      description:
        "We foster a culture of innovation, encouraging new ideas and adaptive solutions.",
    },
  ];

  const roadmap2 = [
    {
      step: "1",
      title: "Expanding Global Reach 🌍",
      description:
        "We take time to understand your unique needs, challenges, and goals.",
    },
    {
      step: "2",
      title: "Investing in Emerging Tech 🤖",
      description:
        "Our experts design customized strategies and solutions that align with your business objectives.",
    },
    {
      step: "3",
      title: "Growing a Passionate Team 💼",
      description:
        "From concept to execution, we ensure timely delivery of impactful results.",
    },
  ];

  const faqs = [
    {
      question: "Our Experience?",
      answer: "30+ years combined industry mastery",
    },
    {
      question: "Why Choose Us?",
      answer: "Streamlined, customized, and scalable solutions",
    },
    {
      question: "Your Data’s Safe?",
      answer: "100% compliance and protection",
    },
    {
      question: "Proof of Work? ",
      answer: "Yes, with case studies on request",
    },
  ];
  const scrollToTop = () => {
    const c = document.documentElement.scrollTop || document.body.scrollTop;
    if (c > 0) {
      window.requestAnimationFrame(scrollToTop);
      window.scrollTo(0, c - c / 8); // Smooth easing effect
    }
  };
  const ServiceCard1 = ({ icon, title, description, services, mainPath }) => {
    return (
      <div className="bg-white p-6 rounded-lg border border-gray-200 hover:shadow-md transition-shadow duration-300">
        <div className="flex items-center mb-4">
          <div className="bg-blue-100 p-3 rounded-full mr-4">{icon}</div>
          <h3 className="text-xl font-semibold">
            <Link
              to={mainPath}
              className="hover:text-blue-600 transition-colors"
              onClick={scrollToTop}
            >
              {title}
            </Link>
          </h3>
        </div>
        <p className="text-gray-600 mb-4">{description}</p>
        <ul className="space-y-2">
          {services.map((service, index) => (
            <li key={index} className="flex items-center">
              <Link
                to={service.path}
                className="text-gray-700 hover:text-blue-600 transition-colors flex items-center"
              >
                <span className="mr-2">{service.text.split(" ")[0]}</span>
                {service.text.split(" ").slice(1).join(" ")}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const TeamMember = ({ image, name, role, description }) => (
    <motion.div
      className="bg-white rounded-lg p-6 shadow-lg transition-transform hover:scale-105"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      data-aos="fade-up"
    >
      <div className="flex flex-col items-center">
        <a href={image} target="_blank" rel="noopener noreferrer">
          <img
            src={image}
            style={{ marginTop: "10px" }}
            alt={name}
            className="w-32 h-32 rounded-full objsect-cover"
          />
        </a>
        <h3 className="text-xl font-bold mb-2">{name}</h3>
        <p className="text-blue-600 mb-4">{role}</p>
        {/* <p className="text-gray-600 text-center mb-6">{description}</p> */}
        <div className="flex space-x-4">
          <a href="#" className="text-gray-600 hover:text-blue-600">
            <Facebook size={20} />
          </a>
          <a href="#" className="text-gray-600 hover:text-blue-600">
            <Instagram size={20} />
          </a>
          <a href="#" className="text-gray-600 hover:text-blue-600">
            <Linkedin size={20} />
          </a>
        </div>
      </div>
    </motion.div>
  );

  return (
    <>
      {/* Hero with Background Image */}
      <div className="min-h-screen flex flex-col relative mb-16">
        {/* Background Image with Overlay from external CSS */}
        <div className="hero-background" />

        {/* Centered Hero Text */}
        <div
          className="relative z-10 flex flex-col main-content items-center justify-center text-center mb-16 flex-grow"
          style={{ marginTop: "370px" }}
        >
          <h1
            className="text-white text-6xl font-bold mb-6"
            style={{ fontSize: "60px" }}
            data-aos="fade-down"
          >
            We Are Serving Round The Clock
          </h1>
          <div
            className="flex items-center justify-center text-white text-xl space-x-4"
            style={{ fontSize: "22px" }}
            data-aos="fade-up"
          >
            <span>BPO</span>
            <span className="text-2xl">•</span>
            <span>Healthcare</span>
            <span className="text-2xl">•</span>
            <span>Digital Marketing</span>
          </div>
        </div>
      </div>

      {/* Page Content */}
      <div className="min-h-screen bg-gray-50 font-sans">
        {/* Intro Hero */}
        <div className="bg-gradient-to-r mb-20 from-blue-50 to-indigo-100 py-20">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
              {/* Left Side - Text Content */}
              <div data-aos="fade-right">
                <h1 className="text-4xl md:text-5xl font-bold mb-6">
                  <span className="text-gray-900">Optimized Business </span>
                  <span className="text-blue-600">Solutions</span>
                </h1>
                <p className="text-lg text-gray-700">
                  At Right On Time Services, we’re not just service
                  providers—we're strategic partners. Our goal is to fuel your
                  success through expert-led BPO, healthcare support, digital
                  marketing, and cutting-edge software development. Powered by
                  experience, driven by results.
                </p>
              </div>

              {/* Right Side - Image */}
              <div data-aos="fade-left">
                <img
                  src={pic1}
                  alt="Optimized Solutions"
                  className="w-full rounded-lg "
                />
              </div>
            </div>
          </div>
        </div>

        {/* Services Section */}
        {/* <section id="services" className="py-20 mb-16  bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4" data-aos="fade-up">
                What We Do Best
              </h2>
              <p
                className="text-gray-600 max-w-3xl mx-auto"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                We provide a wide range of services tailored to meet your
                business needs and help you achieve your goals.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8  shadow-lg">
              {services.map((service, index) => (
                <ServiceCard
                  key={index}
                  icon={service.icon}
                  title={service.title}
                  description={service.description}
                  services={service.services}
                />
              ))}
            </div>
          </div>
        </section> */}

        <section id="services" className="py-20 mb-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4" data-aos="fade-up">
                What We Do Best
              </h2>
              <p
                className="text-gray-600 max-w-3xl mx-auto"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                We provide a wide range of services tailored to meet your
                business needs and help you achieve your goals.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {services.map((service, index) => (
                <ServiceCard1
                  key={index}
                  icon={service.icon}
                  title={service.title}
                  description={service.description}
                  services={service.services}
                  mainPath={service.mainPath}
                />
              ))}
            </div>
          </div>
        </section>
        {/* Leadership Section */}
        <section id="leadership" className="py-20 mb-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4" data-aos="fade-up">
                Meet the Minds Behind Our Mission
              </h2>
              {/* <p
                className="text-gray-600 max-w-3xl mx-auto"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Our leadership team is dedicated to innovation, excellence, and
                delivering results. With diverse expertise and a unified vision,
                our leaders drive the success of our clients and our company.
              </p> */}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
              {team.map((member, index) => (
                <TeamMember
                  key={index}
                  image={member.image}
                  name={member.name}
                  role={member.role}
                  description={member.description}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Roadmap Section */}
        <section id="roadmap" className="py-20 mb-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">How We Make It Happen</h2>
              {/* <p className="text-gray-600 max-w-3xl mx-auto">
                Our approach is built on discovery, collaboration, and
                innovation, guiding you through a seamless journey to success.
              </p> */}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {roadmap.map((step, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg p-6 shadow-lg border-t-4 border-blue-600"
                >
                  <div className="text-4xl font-bold text-blue-600 mb-4">
                    {step.step}
                  </div>
                  <h3 className="text-xl font-bold mb-2">{step.title}</h3>
                  {/* <p className="text-gray-600">{step.description}</p> */}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 bg-gray-100">
          <div className="max-w-6xl mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-blue-900 mb-8">
              Looking Ahead: Our Vision
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-lg shadow hover:shadow-xl transition">
                <h3 className="text-xl font-semibold text-gray-800">
                  Expanding Global Reach 🌍
                </h3>
              </div>
              <div className="bg-white p-6 rounded-lg shadow hover:shadow-xl transition">
                <h3 className="text-xl font-semibold text-gray-800">
                  Investing in Emerging Tech 🤖
                </h3>
              </div>
              <div className="bg-white p-6 rounded-lg shadow hover:shadow-xl transition">
                <h3 className="text-xl font-semibold text-gray-800">
                  Growing a Passionate Team 💼
                </h3>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
              {/* Left Side - Image */}
              <div data-aos="fade-right">
                <img
                  src={pic2}
                  alt="Recognized for Results"
                  className="w-full rounded-lg"
                />
              </div>

              {/* Right Side - Text Content */}
              <div className="text-center md:text-left" data-aos="fade-left">
                <FaTrophy className="text-yellow-500 text-4xl mb-4 mx-auto md:mx-0" />
                <h2 className="text-3xl font-bold text-blue-900 mb-4">
                  Recognized for Results
                </h2>
                <div className="flex justify-center md:justify-start mb-4">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-400 text-xl mx-1" />
                  ))}
                </div>
                <p className="text-gray-700 max-w-md">
                  Our accolades reflect our commitment to excellence,
                  consistency, and client success stories.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Achievements Section */}
        {/* <section className="py-20 mb-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">Achievements & Awards</h2>
              <p className="text-gray-600 max-w-3xl mx-auto">
                Our achievements highlight our commitment to excellence and
                client satisfaction. Let our success stories inspire your
                journey.
              </p>
            </div>
            <div className="text-center">
              <h3 className="text-2xl font-bold mb-4">Success Stories</h3>
              <p className="text-gray-600 max-w-3xl mx-auto mb-8">
                Gain insights and learn from the experiences of our valued
                clients.
              </p>
              
            </div>
          </div>
        </section> */}

        {/* Contact Form Section */}
        <section id="contact" className="py-20 mb-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">
                Let's Start Something Great
              </h2>
              <p className="text-gray-600 max-w-3xl mx-auto">
                Fill out the form below and we'll get back to you as soon as
                possible.
              </p>
            </div>
            <div className="max-w-3xl mx-auto">
              <form
                onSubmit={handleSubmit}
                className="grid grid-cols-1 md:grid-cols-2 gap-6"
              >
                <div>
                  <label htmlFor="service" className="block text-gray-700 mb-2">
                    Select Service
                  </label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleFormChange}
                    className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    <option value="">Select a service</option>
                    <option value="bpo">Business Process Outsourcing</option>
                    <option value="healthcare">Healthcare Solutions</option>
                    <option value="digital">Digital Marketing</option>
                    <option value="software">Software Development</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="name" className="block text-gray-700 mb-2">
                    Your Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleFormChange}
                    className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-gray-700 mb-2">
                    Your Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleFormChange}
                    className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-gray-700 mb-2">
                    📞 Your Phone
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleFormChange}
                    className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div className="md:col-span-2">
                  <label htmlFor="subject" className="block text-gray-700 mb-2">
                    Enter Subject
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleFormChange}
                    className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div className="md:col-span-2">
                  <label
                    htmlFor="description"
                    className="block text-gray-700 mb-2"
                  >
                    Project Description
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={handleFormChange}
                    rows={5}
                    className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  ></textarea>
                </div>
                <div className="md:col-span-2 text-center">
                  <button
                    style={{ background: "darkblue", color: "white" }}
                    type="submit"
                    className="px-8 mt-4 py-3 rounded-md font-medium hover:bg-blue-700 transition-colors flex items-center justify-center mx-auto"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <svg
                          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Submitting...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Success Dialog */}
          {showSuccessDialog && (
            <motion.div
              className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <motion.div
                className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4 overflow-hidden"
                initial={{ scale: 0.9, y: 20 }}
                animate={{ scale: 1, y: 0 }}
                transition={{ type: "spring", damping: 25 }}
              >
                <div className="p-6 text-center">
                  <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
                    <svg
                      className="h-10 w-10 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    Thank You!
                  </h3>
                  <p className="text-gray-600 mb-6">
                    Your message has been sent successfully. <br />
                    <span className="font-semibold text-blue-600">
                      Right On Time
                    </span>{" "}
                    will contact you shortly.
                  </p>
                  <button
                    onClick={() => setShowSuccessDialog(false)}
                    className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                  >
                    Got it!
                  </button>
                </div>
              </motion.div>
            </motion.div>
          )}
        </section>

        {/* FAQ Section */}
        <section id="faq" className="py-20 mb-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">
                Have Questions? We’ve Got Answers
              </h2>
              <p className="text-gray-600 max-w-3xl mx-auto">
                Find answers to frequently asked questions about our services
                and process.
              </p>
            </div>
            <div className="max-w-3xl mx-auto text-center space-y-6">
              {faqs.map((faq, index) => (
                <div key={index} className="bg-white rounded-lg p-6">
                  <h3 className="text-xl font-bold mb-2">{faq.question}</h3>
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
